var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.893 3.15234H4C2.897 3.15234 2 4.04934 2 5.15234V19.1523C2 20.2553 2.897 21.1523 4 21.1523H19.893C20.996 21.1523 21.893 20.2553 21.893 19.1523V5.15134C21.8919 4.62133 21.6809 4.11334 21.306 3.73865C20.9311 3.36397 20.423 3.15314 19.893 3.15234ZM8 19.1523H4V8.15134H8V19.1523ZM14 19.1523H10V8.15134H14V19.1523ZM16 19.1523V8.15134H19.893L19.894 19.1523H16Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColumns);
export default __webpack_public_path__ + "static/media/icons-columns.3db10f011ad02573485a13aec20713e9.svg";
export { ForwardRef as ReactComponent };